import { useTranslation } from "react-i18next";
import { Form, FormInstance, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";

import SettingContentCourse from "../setting-content-course";
import TabInstructor from "./tab-instructor";
import TabSettingPublish from "./tab-setting-publish";
import EvaluateSetting from "./tab-evalute";
import AttendanceSetting from "./tab-attendance/AttendanceSetting";

import {
  getCertificationCourse,
  getCostCourse,
  getInstructTeacher,
  getUnitsToSettingAttendance,
} from "../../../../service/content-course/contenCourseApi";
import { usePreventRouteChange } from "../../../../hooks/usePreventRouteChange";

import "./index.scss";

type TabsSettingCommonProps = {
  form: FormInstance;
  onFinish?: (name: string, { forms, values }: any) => void;
  isCertificate: boolean;
  certificateId: number;
  setCertificateId: (value: number) => void;
  setIsCertificate: (value: boolean) => void;
  detailData: any;
  initialValues: any;
  isDirty: boolean;
  tabForm: string;
  courseStatus: number;
  courseDetail: any;
  setTabForm: (value: string) => void;
  setDirty: (value: boolean) => void;
  resetForm: () => void;
  certificateDetails: any;
};

const TabsSettingCommon = ({
  form,
  onFinish,
  isCertificate,
  certificateId,
  setCertificateId,
  setIsCertificate,
  detailData,
  initialValues,
  isDirty,
  setDirty,
  tabForm,
  setTabForm,
  resetForm,
  courseDetail,
  courseStatus,
  certificateDetails,
}: TabsSettingCommonProps) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { confirmNavigation } = usePreventRouteChange();
  const [isRevoke, setIsRevoke] = useState(false);
  const [reload, setReload] = useState(true);

  const [dataConfigDetail, setDataConfigDetail] = useState({
    dataInstructorTeacher: [],
    dataCertificateCourse: [],
    dataCostCourse: [],
    dataUnit: [],
  });

  const methodFeeValue = Form.useWatch("isCostFree", form);

  const handleChange = (value: string) => {
    confirmNavigation({ link: "" }, false, () => {
      setTabForm(value);
    });
  };

  const fetchAllData = async (courseId: number) => {
    try {
      const [instructorRes, certRes, costRes, unitRes] = await Promise.allSettled([
        getInstructTeacher(courseId),
        getCertificationCourse(courseId),
        getCostCourse(courseId),
        getUnitsToSettingAttendance(courseId),
      ]);

      setDataConfigDetail(prev => ({
        ...prev,
        dataInstructorTeacher: instructorRes.status === "fulfilled" ? instructorRes.value?.data?.data : [],
        dataCertificateCourse: certRes.status === "fulfilled" ? certRes.value?.data?.data : [],
        dataCostCourse: costRes.status === "fulfilled" ? costRes.value?.data?.data : [],
        dataUnit: unitRes.status === "fulfilled" ? unitRes.value?.data?.data : [],
      }));
    } catch (err) {
      console.error("Error fetching course config:", err);
    } finally {
      setReload(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchAllData(Number(id));
    }
  }, [id, isRevoke, reload]);

  const items = [
    {
      key: "1",
      label: t("Cài đặt chung", "Cài đặt chung"),
      children: (
        <Form.Provider
          onFormFinish={onFinish}
          onFormChange={(formName, info: { changedFields: any[]; forms: any }) => {
            if (info.changedFields?.length && !isEmpty(info.changedFields[0].value)) {
              setDirty(true);
            }
          }}
        >
          <Form form={form} initialValues={initialValues}>
            <SettingContentCourse
              resetForm={resetForm}
              isCertificate={isCertificate}
              certificateId={certificateId}
              dataSetting={detailData}
              form={form}
              setCertificateId={setCertificateId}
              setIsCertificate={setIsCertificate}
            />
          </Form>
        </Form.Provider>
      ),
    },
    {
      key: "2",
      label: t("Người hướng dẫn", "Người hướng dẫn"),
      children: (
        <TabInstructor
          dataInstructorTeacher={dataConfigDetail.dataInstructorTeacher}
          isDirty={isDirty}
          setDirty={setDirty}
          setReload={setReload}
          reload={reload}
        />
      ),
    },
    {
      key: "3",
      label: t("Xuất bản", "Xuất bản"),
      children: (
        <TabSettingPublish
          formWrapper={form}
          dataCostCourse={dataConfigDetail.dataCostCourse}
          dataConfig={detailData}
          methodFeeValue={methodFeeValue}
          isDirty={isDirty}
          setDirty={setDirty}
          courseStatus={courseStatus}
          courseDetail={courseDetail}
          isRevoke={isRevoke}
          setIsRevoke={setIsRevoke}
        />
      ),
    },
    {
      key: "5",
      label: t("Đánh giá", "Đánh giá"),
      children: (
        <EvaluateSetting
          certificateProps={{
            dataCertificateCourse: dataConfigDetail.dataCertificateCourse,
            courseId: Number(id),
            courseDetail: certificateDetails,
          }}
        />
      ),
    },
    {
      key: "6",
      label: t("Điểm danh", "Điểm danh"),
      children: <AttendanceSetting dataUnit={dataConfigDetail.dataUnit} />,
    },
  ];

  return (
    <Tabs
      items={items}
      activeKey={tabForm}
      className="tabs-active-setting"
      tabPosition="left"
      onChange={handleChange}
    />
  );
};

export default TabsSettingCommon;
